import { INetworkInterface, INetworkOptions } from '../../../FrontApplet/Management/Network/INetworkInfo';
import { EmptyObject } from '../../EmptyObject';

export type ManagementNetworkRequests =
	| ManagementNetworkListInterfacesRequest
	| ManagementNetworkSetManualRequest
	| ManagementNetworkSetDHCPServerRequest
	| ManagementNetworkDisableInterfaceRequest
	| ManagementNetworkSendUdpRequest
	| ManagementNetworkSendWakeOnLanRequest;

export const ManagementNetworkListInterfacesRequest = 'sos.Monitoring.Management.Network.ListInterfacesRequest';
export interface ManagementNetworkListInterfacesRequest {
	type: typeof ManagementNetworkListInterfacesRequest;
}

export const ManagementNetworkListInterfacesResult = 'sos.Monitoring.Management.Network.ListInterfacesResult';
export interface ManagementNetworkListInterfacesResult {
	type: typeof ManagementNetworkListInterfacesResult;
	result: INetworkInterface[];
}

export const ManagementNetworkSetManualRequest = 'sos.Monitoring.Management.Network.SetManualRequest';
export interface ManagementNetworkSetManualRequest {
	type: typeof ManagementNetworkSetManualRequest;
	interfaceName: string;
	options: INetworkOptions;
}

export const ManagementNetworkSetManualResult = 'sos.Monitoring.Management.Network.SetManualResult';
export interface ManagementNetworkSetManualResult {
	type: typeof ManagementNetworkSetManualResult;
	result: EmptyObject;
}

export const ManagementNetworkSetDHCPServerRequest = 'sos.Monitoring.Management.Network.SetDHCPServerRequest';
export interface ManagementNetworkSetDHCPServerRequest {
	type: typeof ManagementNetworkSetDHCPServerRequest;
	interfaceName: string;
}

export const ManagementNetworkSetDHCPServerResult = 'sos.Monitoring.Management.Network.SetDHCPServerResult';
export interface ManagementNetworkSetDHCPServerResult {
	type: typeof ManagementNetworkSetDHCPServerResult;
	result: EmptyObject;
}

export const ManagementNetworkDisableInterfaceRequest = 'sos.Monitoring.Management.Network.DisableInterfaceRequest';
export interface ManagementNetworkDisableInterfaceRequest {
	type: typeof ManagementNetworkDisableInterfaceRequest;
	interfaceName: string;
}

export const ManagementNetworkDisableInterfaceResult = 'sos.Monitoring.Management.Network.DisableInterfaceResult';
export interface ManagementNetworkDisableInterfaceResult {
	type: typeof ManagementNetworkDisableInterfaceResult;
	result: EmptyObject;
}

export const ManagementNetworkSendUdpRequest = 'sos.Monitoring.Management.Network.SendUdpRequest';
export interface ManagementNetworkSendUdpRequest {
	type: typeof ManagementNetworkSendUdpRequest;
	ip: string;
	port: number;
	data: number[];
}

export const ManagementNetworkSendUdpResult = 'sos.Monitoring.Management.Network.SendUdpResult';
export interface ManagementNetworkSendUdpResult {
	type: typeof ManagementNetworkSendUdpResult;
	result: EmptyObject;
}

export const ManagementNetworkSendWakeOnLanRequest = 'sos.Monitoring.Management.Network.SendWakeOnLanRequest';
export interface ManagementNetworkSendWakeOnLanRequest {
	type: typeof ManagementNetworkSendWakeOnLanRequest;
	macAddress: string;
}

export const ManagementNetworkSendWakeOnLanResult = 'sos.Monitoring.Management.Network.SendWakeOnLanResult';
export interface ManagementNetworkSendWakeOnLanResult {
	type: typeof ManagementNetworkSendWakeOnLanResult;
	result: EmptyObject;
}
